var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn--main has-icon",on:{"click":function($event){return _vm.$emit('handleClick',_vm.options.action.event)}}},[_vm._v(" "+_vm._s(_vm.options.action.text)+" "),_c('i',{staticClass:"btn-icon btn-action"},[_c('i',{staticClass:"fas",class:'fa-'+_vm.options.action.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }